import { IDeleteItemChecklistEntregaUseCase } from "../../../presentation/useCases/delete/delete_item_checklist_entrega_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DeleteItemChecklistEntregaUseCase
 */

export class DeleteItemChecklistEntregaUseCase implements IDeleteItemChecklistEntregaUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idItemChecklistEntrega: number): Promise<void> {
    await this.repository.deleteItemChecklistEntregaById(idItemChecklistEntrega);
  }
}
